/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setSplash } from "./setSplash";
import { loadSmoothScrollTo } from "./smoothScrollTo";
import { setCreateSpan } from "./setCreateSpan";
import { setDrawerButton } from "./setDrawerButton";
import { setScrollBar } from "./setScrollBar";
import { setScrollTrigger } from './setScrollTrigger';
import { setCreateButton } from "./setCreateButton";
import { setBarba } from "./setBarba";

/**
 * Do modules.
 */
function modules() {
  setSplash();
  loadSmoothScrollTo();
  setCreateSpan();
  setDrawerButton();
  setScrollBar();
  setScrollTrigger();
  setCreateButton();
  setBarba();
}

export { modules };
